import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const ChatBubble = ({
  sender,
  text,
  customKey,
  ...props
}: {
  sender: "user" | "bot";
  text: string;
  customKey: number;
}) => {
  return (
    <div
      key={customKey}
      className={`flex chat-bubble ${sender === "user" ? "justify-end" : "justify-start"}`}
      {...props}
    >
      {text && (
        <div
          className={`px-4 py-3 text-sm ${
            sender === "user"
              ? "max-w-xs rounded-xl rounded-br-sm bg-green-600 text-white"
              : "rounded-xl rounded-bl-sm bg-gray-50 border border-gray-200 text-gray-800 bot-bubble"
          }`}
        >
          {sender === "bot" ? (
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
          ) : (
            text
          )}
        </div>
      )}
    </div>
  );
};

export default ChatBubble;
